import { render } from "./PrenatalExamsTab.vue?vue&type=template&id=6711ad66&scoped=true"
import script from "./PrenatalExamsTab.vue?vue&type=script&lang=js"
export * from "./PrenatalExamsTab.vue?vue&type=script&lang=js"

import "./PrenatalExamsTab.vue?vue&type=style&index=0&id=6711ad66&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6711ad66"]])

export default __exports__